module.exports = __webpack_public_path__ + "61b23e2638549365c329ff55741d8e62.jpg";